import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "success",
  "use": "success-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 52 52\" id=\"success\">\n<title>success</title>\n<desc>Created with Sketch.</desc>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#76BD22\" d=\"M26,0C11.6,0,0,11.6,0,26s11.6,26,26,26s26-11.6,26-26S40.4,0,26,0\n\tz M22.8,36.6L12.6,26.4l3-3l7.2,7.1l15.8-15.8l3,3.1L22.8,36.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol